import { render, staticRenderFns } from "./CoinChoiceDialog.vue?vue&type=template&id=95a6c9f6&scoped=true&"
import script from "./CoinChoiceDialog.vue?vue&type=script&lang=js&"
export * from "./CoinChoiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoinChoiceDialog.vue?vue&type=style&index=0&id=95a6c9f6&prod&lang=less&scoped=true&"
import style1 from "./CoinChoiceDialog.vue?vue&type=style&index=1&id=95a6c9f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a6c9f6",
  null
  
)

export default component.exports